import { appSettingsAppGroupIdMessagePrioritizationRulesData } from "../appSettingsAppGroupIdMessagePrioritizationRulesData";
import type { AllRouteEndpoints } from "../routeTypes";

export const appSettingsAppGroupIdMessagePrioritizationRulesCacheKeys: AllRouteEndpoints[] = [
  appSettingsAppGroupIdMessagePrioritizationRulesData,
];
